import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutSimpleSettingsRequest } from '@/model/repository';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * 簡易設定を取得
 */
export async function fetchSimpleSettings() {
  const fetchedSimpleSettings = await shiftServiceRepositories.simpleSettings.index();
  return fetchedSimpleSettings.data;
}
/**
 * 簡易設定を保存
 */
export async function storeSimpleSettings(payload: PutSimpleSettingsRequest) {
  const fetchedSimpleSettings = await shiftServiceRepositories.simpleSettings.update(payload);
  return fetchedSimpleSettings.data;
}

export default {
  fetchSimpleSettings,
  storeSimpleSettings,
};
